module.exports = __webpack_public_path__ + "img/Weapon_223.dcf8597c.png";